export const maximumPercentage: number = 100;
export const minimumPercentage: number = 0;
export const defaultControlPercentage: number = 10;
export const defaultCampaignSubscriberCap: number = 0;
export const nonSubscriberUniverses: number[] = [9, 10, 11, 12];
